"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Share = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M13.7773501,6.08397485 L19.7773501,10.0839749 C20.0071144,10.2371511 20.0692014,10.5475858 19.9160251,10.7773501 C19.8794077,10.8322762 19.8322762,10.8794077 19.7773501,10.9160251 L13.7773501,14.9160251 C13.5475858,15.0692014 13.2371511,15.0071144 13.0839749,14.7773501 C13.029219,14.6952163 13,14.5987125 13,14.5 L13,13 L12,13 C8.13400675,13 5,16.1340068 5,20 L4,20 L4,17.5 C4,12.4210121 7.98571764,8.27293852 13,8.01293206 L13,6.5 C13,6.22385763 13.2238576,6 13.5,6 C13.5987125,6 13.6952163,6.02921901 13.7773501,6.08397485 Z M14,7.43425855 L14,9 L13.5,9 C9.37082173,9 5.92932485,11.944314 5.16042711,15.8480243 C6.5639865,13.5408782 9.10204756,12 12,12 L14,12 L14,13.5657415 L18.5986122,10.5 L14,7.43425855 Z" })));
};
Share.displayName = 'Share';
exports.default = Share;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Share.js.map